module.exports = __webpack_public_path__ + "static/media/my-friend-active-icon.27b1f1c3.svg";